import { useMemo, useState } from 'react'

type ToggleCallback = (isOn?: boolean) => void

interface ReturnValue {
  isOn: boolean
  on: () => void
  off: () => void
  toggle: (callback?: ToggleCallback) => boolean
  reset: () => void
}

const useToggle = (initialIsOn = false): ReturnValue => {
  const [isOn, setIsOn] = useState(initialIsOn)

  return useMemo(() => {
    return {
      isOn,
      on: () => setIsOn(true),
      off: () => setIsOn(false),
      toggle: callback => {
        let newValue = isOn
        setIsOn(currentIsOn => {
          newValue = !currentIsOn
          callback?.(newValue)
          return newValue
        })
        return newValue
      },
      reset: () => setIsOn(initialIsOn),
    }
  }, [isOn, initialIsOn])
}

export default useToggle
